
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class Menu extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    className: PropTypes.string
  }

  render() {
    const {title, className} = this.props
    const menuClassName = classnames('menu', className)

    return (
      <div className={menuClassName}>
        {title ? <div className='menu_title'>{title}</div> : null}
        <ul className='menu_list'>
          {this.props.children}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Menu/index.js